import { render, staticRenderFns } from "./ClientAffiliationTable.vue?vue&type=template&id=04b86155&scoped=true&"
import script from "./ClientAffiliationTable.vue?vue&type=script&lang=js&"
export * from "./ClientAffiliationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b86155",
  null
  
)

export default component.exports